import { render, staticRenderFns } from "./forward.vue?vue&type=template&id=8d6143bc&scoped=true&"
import script from "./forward.vue?vue&type=script&lang=js&"
export * from "./forward.vue?vue&type=script&lang=js&"
import style0 from "./forward.vue?vue&type=style&index=0&id=8d6143bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d6143bc",
  null
  
)

export default component.exports